import React from "react";
import FormWizardFormWrapper from "../../FormWizardFormWrapper";
import PageFormWidget from "../PageFormWidget/PageFormWidget";
import PageFormButtons from "../PageFormButtons/PageFormButtons";
import { useForm } from "react-hook-form";
import "./PageFormSummaryStep.scss";
import type { FormWizardStep } from "../../types";

type PageFormSummaryStepProps = {
  defaultValues?: Record<string, any>;
  onValidate?: (data: Record<string, any>) => void;
  steps: FormWizardStep[];
};

const PageFormSummaryStep: React.FC<PageFormSummaryStepProps> = ({
  defaultValues,
  onValidate = () => {},
  steps,
}) => {
  const methods = useForm({
    mode: "all",
    values: defaultValues,
  });
  const { handleSubmit, getValues } = methods;

  return (
    <FormWizardFormWrapper
      handleSubmit={handleSubmit}
      onSubmit={onValidate}
      getValues={getValues}
      className="summary-step-form"
    >
      <PageFormWidget>
        {steps.map((step) => {
          return (
            <div key={step.id} className="summary-step-section">
              <div
                className="summary-step-section-title"
                data-testid={`summary-step-section-title`}
              >
                {step.name}
              </div>
              {React.cloneElement(step.form, {
                key: step.id,
                defaultValues,
                isSummary: true,
              })}
            </div>
          );
        })}
      </PageFormWidget>
      <PageFormButtons data-testid="summary-step-buttons" />
    </FormWizardFormWrapper>
  );
};

export default PageFormSummaryStep;
